import React, { useState, useEffect } from 'react';
import vendorDashboardService from '../../services/vendorDashboardService';
import ExportButton from '../../components/ExportButton/ExportButton';
import { exportVendorDashboardIssues } from '../../services/exportService';
import { toast } from 'react-toastify';
import './VendorIssues.css';
import userService from '../../services/userService';

const VendorIssues = () => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    status: '',
    severity: '',
    search: '',
    page: 1,
    limit: 10
  });
  const [errors, setErrors] = useState({});

  const [pagination, setPagination] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingIssue, setEditingIssue] = useState(null);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [analytics, setAnalytics] = useState({
    total: 0,
    open: 0,
    inProgress: 0,
    resolved: 0,
    closed: 0,
    critical: 0,
    high: 0,
    medium: 0,
    low: 0
  });
  const [formData, setFormData] = useState({
    project_id: '',
    title: '',
    description: '',
    issue_type: 'Bug',
    severity: 'Medium',
    status: 'Open',
    assigned_to: '',
    resolution: ''
  });

  useEffect(() => {
    loadIssues();
    loadProjects();
    // loadUsers();
  }, [filters]);

  const loadIssues = async () => {
    try {
      setLoading(true);
      const data = await vendorDashboardService.getIssues(filters);
      setIssues(data.issues || []);
      setPagination(data.pagination);
      calculateAnalytics(data.issues || []);
      setError(null);
    } catch (err) {
      console.error('Error loading issues:', err);
      setError('Failed to load issues');
    } finally {
      setLoading(false);
    }
  };

  const handleProjectChange = async (e) => {
    const value = e.target.value;

    console.log("appii",)

    setFormData((prev) => ({
      ...prev,
      project_id: value,
    }));

    try {
          console.log("appii")

      const data = await vendorDashboardService.getAllAssignedUsers(value);
      console.log("users", data)
      setUsers(data.users || []);
      console.log(data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const calculateAnalytics = (issuesList) => {
    const stats = {
      total: issuesList.length,
      open: 0,
      inProgress: 0,
      resolved: 0,
      closed: 0,
      critical: 0,
      high: 0,
      medium: 0,
      low: 0
    };

    issuesList.forEach(issue => {
      // Count by status
      const status = issue.status?.toLowerCase();
      if (status === 'open') stats.open++;
      else if (status === 'in_progress') stats.inProgress++;
      else if (status === 'resolved') stats.resolved++;
      else if (status === 'closed') stats.closed++;

      // Count by severity
      const severity = issue.severity?.toLowerCase();
      if (severity === 'critical') stats.critical++;
      else if (severity === 'high') stats.high++;
      else if (severity === 'medium') stats.medium++;
      else if (severity === 'low') stats.low++;
    });

    setAnalytics(stats);
  };

  const loadProjects = async () => {
    try {
      const data = await vendorDashboardService.getProjects({ limit: 100 });
      setProjects(data.projects || []);
    } catch (err) {
      console.error('Error loading projects:', err);
    }
  };


  const handleStatusChange = async (issueId, newStatus) => {
    try {
      await vendorDashboardService.updateIssueStatus(issueId, newStatus);
      loadIssues();
    } catch (err) {
      console.error('Error updating issue status:', err);
      alert('Failed to update issue status');
    }
  };

  const handleCreateIssue = async (e) => {
    e.preventDefault();
    try {
      await vendorDashboardService.createIssue(formData);
      setShowCreateModal(false);
      resetForm();
      loadIssues();
      toast.success('Issue created  successfully');

    } catch (err) {
      console.error('Error creating issue:', err);
      toast.error('Failed to create issue');
    }
  };

  const handleEditIssue = async (e) => {
    e.preventDefault();
    try {
      await vendorDashboardService.updateIssue(editingIssue.id, formData);
      setShowEditModal(false);
      setEditingIssue(null);
      resetForm();
      loadIssues();
      alert('Issue updated successfully!');
    } catch (err) {
      console.error('Error updating issue:', err);
      alert('Failed to update issue');
    }
  };

  const openEditModal = (issue) => {
    setEditingIssue(issue);
    setFormData({
      project_id: issue.project_id || '',
      title: issue.title || '',
      description: issue.description || '',
      issue_type: issue.issue_type || 'Bug',
      severity: issue.severity || 'Medium',
      status: issue.status || 'Open',
      assigned_to: issue.assigned_to || '',
      resolution: issue.resolution || ''
    });
    setShowEditModal(true);
  };

  const resetForm = () => {
    setFormData({
      project_id: '',
      title: '',
      description: '',
      issue_type: 'Bug',
      severity: 'Medium',
      status: 'Open',
      assigned_to: '',
      resolution: ''
    });
  };

  const getSeverityColor = (severity) => {
    const colors = {
      critical: '#dc2626',
      high: '#f59e0b',
      medium: '#3b82f6',
      low: '#10b981'
    };
    return colors[severity] || '#6b7280';
  };

  const getStatusColor = (status) => {
    const colors = {
      open: '#f59e0b',
      in_progress: '#3b82f6',
      resolved: '#10b981',
      closed: '#6b7280'
    };
    return colors[status] || '#6b7280';
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleExport = async (format) => {
    try {
      await exportVendorDashboardIssues(format, filters);
      toast.success(`Issues exported successfully as ${format.toUpperCase()}`);
    } catch (error) {
      toast.error('Failed to export issues');
      console.error('Export error:', error);
    }
  };

  const loadUsers = async () => {
    try {
      // This would need a user service - for now using mock data
      const data = await vendorDashboardService.getAllUsers();
      console.log("users", data)
      setUsers(data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  const loadAssignedUsers = async () => {
    try {
      // This would need a user service - for now using mock data
      const data = await vendorDashboardService.getAllAssignedUsers();
      console.log("users", data)
      setUsers(data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };
  return (
    <div className="vendor-issues">
      {/* Header */}
      <div className="issues-header">
        <div className="header-content">
          <h1><i className="fas fa-exclamation-circle"></i> Issues</h1>
          <p>Manage and track your assigned issues</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <ExportButton
            onExport={handleExport}
            formats={['excel', 'csv', 'pdf']}
            label="Export Issues"
          />
          <button
            className="btn-create"
            onClick={() => setShowCreateModal(true)}
          >
            <i className="fas fa-plus"></i> Create Issue
          </button>
        </div>
      </div>

      {/* Analytics Cards */}
      <div className="analytics-cards">
        <div className="analytics-card analytics-card-total">
          <div className="analytics-icon">
            <i className="fas fa-clipboard-list"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.total}</h3>
            <p>Total Issues</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-open">
          <div className="analytics-icon">
            <i className="fas fa-folder-open"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.open}</h3>
            <p>Open</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-progress">
          <div className="analytics-icon">
            <i className="fas fa-spinner"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.inProgress}</h3>
            <p>In Progress</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-resolved">
          <div className="analytics-icon">
            <i className="fas fa-check-circle"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.resolved}</h3>
            <p>Resolved</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-closed">
          <div className="analytics-icon">
            <i className="fas fa-times-circle"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.closed}</h3>
            <p>Closed</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-critical">
          <div className="analytics-icon">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.critical}</h3>
            <p>Critical</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-high">
          <div className="analytics-icon">
            <i className="fas fa-arrow-up"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.high}</h3>
            <p>High Priority</p>
          </div>
        </div>

        <div className="analytics-card analytics-card-medium">
          <div className="analytics-icon">
            <i className="fas fa-minus-circle"></i>
          </div>
          <div className="analytics-content">
            <h3>{analytics.medium}</h3>
            <p>Medium Priority</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-section">
        <div className="filter-group">
          <input
            type="text"
            placeholder="Search issues..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value, page: 1 })}
            className="search-input"
          />
        </div>
        <div className="filter-group">
          <select
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value, page: 1 })}
            className="filter-select"
          >
            <option value="">All Status</option>
            <option value="open">Open</option>
            <option value="in_progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="closed">Closed</option>
          </select>
        </div>
        <div className="filter-group">
          <select
            value={filters.severity}
            onChange={(e) => setFilters({ ...filters, severity: e.target.value, page: 1 })}
            className="filter-select"
          >
            <option value="">All Severity</option>
            <option value="critical">Critical</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>
        <button onClick={loadIssues} className="btn-refresh">
          <i className="fas fa-sync-alt"></i> Refresh
        </button>
      </div>

      {/* Issues List */}
      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading issues...</p>
        </div>
      ) : error ? (
        <div className="error-container">
          <p>{error}</p>
          <button onClick={loadIssues} className="btn-retry">Retry</button>
        </div>
      ) : issues.length === 0 ? (
        <div className="empty-state">
          <i className="fas fa-inbox"></i>
          <h3>No Issues Found</h3>
          <p>You don't have any issues assigned yet</p>
        </div>
      ) : (
        <>
          <div className="issues-grid">
            {issues.map((issue) => (
              <div key={issue.id} className="issue-card">
                <div className="issue-header">
                  <div className="issue-badges">
                    <span
                      className="severity-badge"
                      style={{ backgroundColor: getSeverityColor(issue.severity) }}
                    >
                      {issue.severity?.toUpperCase()}
                    </span>
                    <span
                      className="status-badge"
                      style={{ backgroundColor: getStatusColor(issue.status) }}
                    >
                      {issue.status?.replace('_', ' ').toUpperCase()}
                    </span>
                  </div>
                  <div className="issue-actions">
                    <button
                      className="btn-icon"
                      onClick={() => setSelectedIssue(issue)}
                      title="View Details"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      className="btn-icon"
                      onClick={() => openEditModal(issue)}
                      title="Edit Issue"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                  </div>
                </div>

                <div className="issue-content">
                  <h3 className="issue-title">{issue.title}</h3>
                  <p className="issue-description">
                    {issue.description?.substring(0, 150)}
                    {issue.description?.length > 150 ? '...' : ''}
                  </p>
                </div>

                <div className="issue-meta">
                  <div className="meta-item">
                    <i className="fas fa-project-diagram"></i>
                    <span>{issue.project?.name || 'No Project'}</span>
                  </div>
                  <div className="meta-item">
                    <i className="fas fa-calendar"></i>
                    <span>{formatDate(issue.createdAt)}</span>
                  </div>
                </div>

                <div className="issue-footer">
                  <select
                    value={issue.status}
                    onChange={(e) => handleStatusChange(issue.id, e.target.value)}
                    className="status-select"
                  >
                    <option value="open">Open</option>
                    <option value="In Progress">In Progress</option>
                    <option value="resolved">Resolved</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {pagination && pagination.totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setFilters({ ...filters, page: filters.page - 1 })}
                disabled={filters.page === 1}
                className="btn-page"
              >
                <i className="fas fa-chevron-left"></i> Previous
              </button>
              <span className="page-info">
                Page {pagination.page} of {pagination.totalPages}
              </span>
              <button
                onClick={() => setFilters({ ...filters, page: filters.page + 1 })}
                disabled={filters.page === pagination.totalPages}
                className="btn-page"
              >
                Next <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          )}
        </>
      )}

      {/* Issue Detail Modal */}
      {selectedIssue && (
        <div className="modal-overlay" onClick={() => setSelectedIssue(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 style={{color:'#fff'}}>Issue Details</h2>
              <button
                className="btn-close"
                onClick={() => setSelectedIssue(null)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="detail-badges">
                <span
                  className="severity-badge"
                  style={{ backgroundColor: getSeverityColor(selectedIssue.severity) }}
                >
                  {selectedIssue.severity?.toUpperCase()}
                </span>
                <span
                  className="status-badge"
                  style={{ backgroundColor: getStatusColor(selectedIssue.status) }}
                >
                  {selectedIssue.status?.replace('_', ' ').toUpperCase()}
                </span>
              </div>
              <h3>{selectedIssue.title}</h3>
              <div className="detail-section">
                <label>Description</label>
                <p>{selectedIssue.description || 'No description provided'}</p>
              </div>
              <div className="detail-section">
                <label>Project</label>
                <p>{selectedIssue.project?.name || 'No Project'}</p>
              </div>
              <div className="detail-section">
                <label>Created</label>
                <p>{formatDate(selectedIssue.createdAt)}</p>
              </div>
              <div className="detail-section">
                <label>Last Updated</label>
                <p>{formatDate(selectedIssue.updated_at)}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Create Issue Modal */}
      {showCreateModal && (
        <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="modal-content modal-form" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 style={{color:'#fff'}}><i className="fas fa-plus-circle"></i> Create New Issue</h2>
              <button
                className="btn-close"
                onClick={() => setShowCreateModal(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <form onSubmit={handleCreateIssue} className="modal-body">
              <div className="form-group">
                <label>Project *</label>
                <select
                  value={formData.project_id}
                  onChange={handleProjectChange}
                  required
                  className="form-control"
                >
                  <option value="">Select Project</option>
                  {projects.map(project => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="parent_task_id">Assignee </label>
                <select
                  id="assigned_to"
                  name="assigned_to"
                  value={formData.assigned_to}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Select assignee"
                >
                  <option value="">Unassigned</option>
                  {users.map(user => (
                    <option key={user.id} value={user.id}>
                      {user.first_name} {user.last_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Title *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                  className="form-control"
                  placeholder="Enter issue title"
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  className="form-control"
                  rows="4"
                  placeholder="Describe the issue..."
                />
              </div>

              {/* <div className="form-row"> */}
              <div className="form-group">
                <label>Issue Type</label>
                <select
                  value={formData.issue_type}
                  onChange={(e) => setFormData({ ...formData, issue_type: e.target.value })}
                  className="form-control"
                >
                  <option value="Bug">Bug</option>
                  <option value="Feature Request">Feature Request</option>
                  <option value="Enhancement">Enhancement</option>
                  <option value="Task">Task</option>
                  <option value="Question">Question</option>
                </select>
              </div>

              <div className="form-group">
                <label>Severity</label>
                <select
                  value={formData.severity}
                  onChange={(e) => setFormData({ ...formData, severity: e.target.value })}
                  className="form-control"
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>
              </div>
              {/* </div> */}

              <div className="form-group">
                <label>Status</label>
                <select
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  className="form-control"
                >
                  <option value="Open">Open</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Resolved">Resolved</option>
                  <option value="Closed">Closed</option>
                </select>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => setShowCreateModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-primary">
                  <i className="fas fa-check"></i> Create Issue
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Issue Modal */}
      {showEditModal && editingIssue && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-content modal-form" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 style={{color:'#fff'}}><i className="fas fa-edit"></i> Edit Issue</h2>
              <button
                className="btn-close"
                onClick={() => setShowEditModal(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <form onSubmit={handleEditIssue} className="modal-body">
              <div className="form-group">
                <label>Project *</label>
                <select
                  value={formData.project_id}
                  onChange={(e) => setFormData({ ...formData, project_id: e.target.value })}
                  required
                  className="form-control"
                >
                  <option value="">Select Project</option>
                  {projects.map(project => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Assignee *</label>
                <select
                  id="assigned_to"
                  name="assigned_to"
                  value={String(formData.assigned_to || '')}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">Unassigned</option>
                  {users.map(user => (
                    <option key={user.id} value={String(user.id)}>
                      {user.first_name} {user.last_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Title *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                  className="form-control"
                  placeholder="Enter issue title"
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  className="form-control"
                  rows="4"
                  placeholder="Describe the issue..."
                />
              </div>

              {/* <div className="form-row"> */}
              <div className="form-group">
                <label>Issue Type</label>
                <select
                  value={formData.issue_type}
                  onChange={(e) => setFormData({ ...formData, issue_type: e.target.value })}
                  className="form-control"
                >
                  <option value="Bug">Bug</option>
                  <option value="Feature Request">Feature Request</option>
                  <option value="Enhancement">Enhancement</option>
                  <option value="Task">Task</option>
                  <option value="Question">Question</option>
                </select>
              </div>

              <div className="form-group">
                <label>Severity</label>
                <select
                  value={formData.severity}
                  onChange={(e) => setFormData({ ...formData, severity: e.target.value })}
                  className="form-control"
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>
              </div>
              {/* </div> */}

              <div className="form-group">
                <label>Status</label>
                <select
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  className="form-control"
                >
                  <option value="Open">Open</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Resolved">Resolved</option>
                  <option value="Closed">Closed</option>
                </select>
              </div>

              <div className="form-group">
                <label>Resolution</label>
                <textarea
                  value={formData.resolution}
                  onChange={(e) => setFormData({ ...formData, resolution: e.target.value })}
                  className="form-control"
                  rows="3"
                  placeholder="Enter resolution details..."
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-primary">
                  <i className="fas fa-save"></i> Update Issue
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorIssues;

